"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- old icon names / keys used in mapping */

const mapping = {
  'v-icon-dashboard-outlined': _icons.Dashboard,
  'v-icon-sales-outlined': _icons.Sales,
  'v-icon-whats-new': _icons.WhatsNew,
  'v-icon-wallet': _icons.Box,
  'v-icon-network-outlined': _icons.Network,
  'v-icon-academy': _icons.Academy,
  'v-icon-new-user-outlined': _icons.NewUser,
  'v-icon-favourite-outlined': _icons.Favourite,
  'v-icon-message-outlined': _icons.Message,
  'v-icon-settings-outlined': _icons.Settings,
  'v-icon-upgrade-outlined': _icons.Upgrade,
  'v-icon-clock-outlined': _icons.Clock,
  'v-icon-oriflame-symbol': _icons.Oriflame,
  'v-icon-chart': _icons.Chart,
  'v-icon-earnings': _icons.MyBenefits,
  'v-icon-reward-plan': _icons.RewardPlan
};
const Root = (0, _mui.styled)(_mui.Box)(({
  theme
}) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(3),
  height: theme.spacing(6)
}));
const Icon = ({
  icon
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  if (icon === null) {
    return null;
  }
  const iconKey = icon.replace(/ [\w-]+/g, '');
  const MenuIcon = iconKey in mapping ? mapping[iconKey] : undefined;
  if (MenuIcon === undefined) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuIcon, {
      sx: {
        fontSize: '28px'
      },
      ...getTestIdProps(`Icon-${iconKey}`)
    })
  });
};
exports.Icon = Icon;